import { BaseService } from '../../Global/services/baseService';
import { AuthActions } from '../actions/authActions';

export class AuthService {

    static PROCESS_REFRESH = false;
    // eslint-disable-next-line no-magic-numbers
    static DEFAULT_MIN_PASSWORD_LENGTH = 8;

    /**
     * Получаем информацию по пользователю
     * @param userProfile
     * @returns {null|any}
     */
    static getUserInfo(userProfile = null) {
        try {
            if (userProfile) {
                userProfile.personality = userProfile.personality && (userProfile.personality.lastName || userProfile.personality.firstName) ? userProfile.personality : {
                    lastName: userProfile.personality && userProfile.personality.lastName ? userProfile.personality.lastName : 'Анонимный',
                    firstName: userProfile.personality && userProfile.personality.firstName ? userProfile.personality.firstName : 'Пользователь',
                };
                userProfile.personality.name = userProfile.personality.name ? userProfile.personality.name : `${userProfile.personality.lastName ? userProfile.personality.lastName : ''} ${userProfile.personality.firstName ? userProfile.personality.firstName : ''} ${userProfile.personality.middleName ? userProfile.personality.middleName : ''}`;
                if (!userProfile.contacts) {
                    userProfile.contacts = {};
                }
                if (!userProfile.address) {
                    userProfile.address = {};
                }
                return userProfile;
            }
            return JSON.parse(BaseService.getCookieValue(BaseService.USER_INFO_COOKIE));
        }
        catch (ex) {
            return null;
        }
    }

    /**
     * Запишем информацию о пользователе
     */
    static setUserInfo(userInfo) {
        let oldUserInfo = AuthService.getUserInfo();
        let newUserInfo = oldUserInfo ? userInfo ? Object.assign(oldUserInfo, userInfo) : null : userInfo;
        if (newUserInfo) {
            newUserInfo.personality = newUserInfo.personality && (newUserInfo.personality.lastName || newUserInfo.personality.firstName) ? newUserInfo.personality : {
                lastName: newUserInfo.personality && newUserInfo.personality.lastName ? newUserInfo.personality.lastName : 'Анонимный',
                firstName: newUserInfo.personality && newUserInfo.personality.firstName ? newUserInfo.personality.firstName : 'Пользователь',
            };
            BaseService.setCookie(BaseService.USER_INFO_COOKIE, JSON.stringify(newUserInfo));
        }
        else {
            BaseService.deleteCookie(BaseService.USER_INFO_COOKIE);
        }
    }

    /**
     * Получить роли пользователя
     * @returns {string[]}
     */
    static getUserRoles() {
        const userInfo = AuthService.getUserInfo();
        return userInfo && userInfo.currentUser && userInfo.currentUser.authorities
            ? userInfo.currentUser.authorities
            : [];
    }

    /**
     * Пользователь имеет данную роль
     * @param role
     * @returns {boolean}
     */
    static userHasRole(role) {
        const userRoles = this.getUserRoles();
        if (!userRoles) return false;
        return userRoles.includes(role);
    }

    /**
     * Пользователь имеет хотя бы одну из указанных ролей
     * @param {string[]} roles
     */
    static userHasOneRole(roles) {
        return roles.some(role => AuthService.userHasRole(role));
    }

    /**
     * Выйти из учётки
     */
    static logOut() {
        window.location = window.location.href.split('#')[0] + '#/login';

        const afterLogoutCallback = () => {
            AuthService.setUserInfo(null);
        };

        AuthActions.logOut()
            .finally(afterLogoutCallback);

    }

    /**
     * Проверяем пароль на длину
     * @param {*} password
     * @param {*} length
     */
    static checkSymbolsLength(password, length = AuthService.DEFAULT_MIN_PASSWORD_LENGTH) {
        if (!password) {
            return false;
        }
        return password.length >= length;
    }

    /**
     * Проверяем, что в пароле есть латинские буквы
     * @param {*} password
     */
    static checkLetters(password) {
        if (!password) {
            return false;
        }
        const regExp = /[a-zA-Z]/;
        return regExp.test(password);
    }

    /**
     * Проверяем, что в пароле есть маленькие латинские буквы
     * @param {*} password
     */
    static checkLowerCase(password) {
        if (!password) {
            return false;
        }
        const regExp = /[a-z]{1}/;
        return regExp.test(password);
    }

    /**
     * Проверяем, что в пароле есть большие латинские буквы
     * @param {*} password
     */
    static checkUpperCase(password) {
        if (!password) {
            return false;
        }
        const regExp = /[A-Z]{1}/;
        return regExp.test(password);
    }

    /**
     * Проверяем, что в пароле есть цифры
     * @param {*} password
     */
    static checkNumbers(password) {
        if (!password) {
            return false;
        }
        const regExp = /[0-9]/;
        return regExp.test(password);
    }
}
